import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "@/data/site";
import PageHero from "@/components/PageHero";
import Breadcrumb from "@/components/Breadcrumb";
import NewsletterSection from "@/components/NewsletterSection";
import useReveal from "@/hooks/useReveal";

export default function Histoire() {
  useReveal([]);
  return (
    <>
      <PageHero
        tag="La Maison"
        title="Notre <em>Histoire</em>"
        subtitle="De Marrakech à votre salle de bain, l'histoire d'une transmission et d'une passion pour la beauté naturelle."
        image={IMAGES.histoireHero}
      />
      <Breadcrumb trail={[{ label: "Accueil", to: "/" }, { label: "Notre histoire" }]} />

      <section className="split reveal">
        <div className="split-img"><img src={IMAGES.splitWomen} alt="Artisanes de l'Atlas" /></div>
        <div className="split-text">
          <p className="section-tag">2019 · Les origines</p>
          <h2 className="section-title">Une rencontre, <em>un héritage.</em></h2>
          <p className="section-body">
            Nerolya Cosmetic est née d'un voyage au cœur de l'Atlas, à la rencontre des femmes berbères
            gardiennes de gestes ancestraux. Émue par leur savoir-faire et la pureté de leurs ingrédients,
            notre fondatrice décide de créer une maison de cosmétique respectueuse de cet héritage.
          </p>
          <p className="section-body">
            Le néroli — cette fleur d'oranger amer distillée avec patience — devient notre signature et
            notre nom. Un symbole de délicatesse, de lumière et de transmission.
          </p>
        </div>
      </section>

      <section className="split reverse reveal">
        <div className="split-img"><img src={IMAGES.splitAtlas} alt="Montagnes de l'Atlas" /></div>
        <div className="split-text">
          <p className="section-tag">Notre mission</p>
          <h2 className="section-title">La cosmétique <em>lente.</em></h2>
          <p className="section-body">
            Nous refusons la production de masse. Chaque flacon est le fruit d'une chaîne courte,
            transparente et équitable : récolte manuelle, extraction à froid, contrôle qualité rigoureux.
            Nous privilégions la qualité à la quantité, le sens à la vitesse.
          </p>
          <Link to="/pages/notre-ethique" className="btn-primary" style={{ alignSelf: "flex-start" }}>Découvrir notre éthique</Link>
        </div>
      </section>

      <NewsletterSection />
    </>
  );
}
